/* eslint-disable import/prefer-default-export */
export const getCategories = state => state.categories
